import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class PhotoService {
    url = environment.devicePhotos;

    constructor(private httpClient: HttpClient) { }

    getPhotoUrls(serialNumber: string | string[]): Promise<PhotoApiResponse[]> {
        if (Array.isArray(serialNumber)) {
            const requests = serialNumber.map(sn => this.httpClient
                .get<PhotoApiResponse[]>(`${this.url}/${sn}`)
                .pipe(catchError(() => of([])))
                .toPromise());
            return Promise.all(requests).then(results => results.flat());
        }
        return this.httpClient
            .get<PhotoApiResponse[]>(`${this.url}/${serialNumber}`)
            .pipe(catchError(() => of([])))
            .toPromise();
    }
}

export interface PhotoApiResponse {
    name: string;
    signedUrl: string;
    photoSavedDate: Date;
}
